// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA0mmrBfBt8GaCSR9MeayTP4fY88QxXgIk",
  authDomain: "house-rental-d9d4f.firebaseapp.com",
  projectId: "house-rental-d9d4f",
  storageBucket: "house-rental-d9d4f.appspot.com",
  messagingSenderId: "777388617793",
  appId: "1:777388617793:web:b8bd4da62bc8859d7b16c0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;